import { PivotFilterOperatorEnum } from '@ztechapps/common.contract'

const O = PivotFilterOperatorEnum

/** Display label per filter operator. */
export const PIVOT_OPERATOR_LABELS: Record<PivotFilterOperatorEnum, string> = {
  [O.equal]: 'Equal',
  [O.not_equal]: 'Not equal',
  [O.begin]: 'Begins with',
  [O.not_begin]: 'Does not begin with',
  [O.end]: 'Ends with',
  [O.not_end]: 'Does not end with',
  [O.contain]: 'Contains',
  [O.not_contain]: 'Does not contain',
  [O.greater]: 'Greater than',
  [O.greater_equal]: 'Greater than or equal to',
  [O.less]: 'Less than',
  [O.less_equal]: 'Less than or equal to',
  [O.between]: 'Between',
  [O.not_between]: 'Not between',
  [O.before]: 'Before',
  [O.before_equal]: 'Before or equal to',
  [O.after]: 'After',
  [O.after_equal]: 'After or equal to',
  [O.last]: 'Last',
  [O.current]: 'Current',
  [O.next]: 'Next',
  [O.top]: 'Top',
  [O.bottom]: 'Bottom',
}
